import React, { useState } from "react";
import { X, Upload, Trash2, Edit2, FileUp } from "lucide-react";
import Swal2 from "sweetalert2";
import withReactContent from "sweetalert2-react-content";
import "./app.css";
import { secretKey } from "./data";

const MySwal = withReactContent(Swal2);
const API = "https://apiftpsplit.ftpeople.pl";

const AddFile = (props) => {
  const [files, setFiles] = useState([]);
  const [renameInputs, setRenameInputs] = useState({});

  const handleFileSelect = (e) => {
    setFiles(Array.from(e.target.files));
    setRenameInputs({});
  };

  const removeFile = (idx) => {
    setFiles((prev) => prev.filter((_, i) => i !== idx));
  };

  const renameFile = (idx) => {
    const newName = renameInputs[idx];
    if (!newName?.trim()) {
      MySwal.fire({
        icon: "error",
        title: "Błąd",
        text: "Wpisz nową nazwę pliku",
      });
      return;
    }
    const ext = files[idx].name.split(".").pop();
    const renamed = new File([files[idx]], `${newName.trim()}.${ext}`, {
      type: files[idx].type,
    });
    setFiles((prev) => prev.map((f, i) => (i === idx ? renamed : f)));
    setRenameInputs((prev) => ({ ...prev, [idx]: "" }));
  };

  const uploadFiles = async () => {
    if (files.length === 0) {
      MySwal.fire({
        icon: "error",
        title: "Wypełnij",
        text: "Wybierz pliki do dodania",
      });
      return;
    }

    try {
      await Promise.all(
        files.map((file) => {
          const fd = new FormData();
          fd.append("file", file);
          fd.append("leadId", props.lead.id);
          fd.append("user", props.user.id);
          fd.append("type", props.type || "plik");
          return fetch(`${API}/addFile`, {
            method: "POST",
            headers: { Authorization: secretKey },
            body: fd,
          });
        })
      );
      MySwal.fire({
        icon: "success",
        title: "Dodano",
        text: `${files.length} ${files.length === 1 ? "plik" : "plików"}`,
      });
      props.close();
    } catch (err) {
      console.error(err);
    }
  };

  return (
    <div
      className="sn-overlay"
      onClick={(e) => {
        if (e.target === e.currentTarget) props.close();
      }}
    >
      <div className="sn-modal" style={{ maxWidth: 600 }}>
        {/* Header */}
        <div className="sn-header">
          <div style={{ display: "flex", alignItems: "center", gap: 10 }}>
            <FileUp size={18} />
            <div>
              <h2 className="sn-title">Dodaj pliki</h2>
              <span className="sn-subtitle">Użytkownik: {props.user.name}</span>
            </div>
          </div>
          <button className="ld-close" onClick={props.close}>
            <X size={18} />
          </button>
        </div>

        <div className="sn-body">
          <div className="af-drop-zone">
            <Upload size={24} />
            <span>Wybierz pliki</span>
            <input
              type="file"
              multiple
              className="af-file-input"
              onChange={handleFileSelect}
            />
          </div>

          {files.length > 0 && (
            <>
              <div className="af-file-list">
                {files.map((file, idx) => (
                  <div key={idx} className="af-file-row">
                    <div className="af-file-name">{file.name}</div>
                    <div className="af-file-rename">
                      <input
                        type="text"
                        className="db-input"
                        placeholder="Nowa nazwa..."
                        value={renameInputs[idx] || ""}
                        onChange={(e) =>
                          setRenameInputs((p) => ({
                            ...p,
                            [idx]: e.target.value,
                          }))
                        }
                        style={{ height: 32, fontSize: 12 }}
                      />
                      <button
                        className="tc-action-btn tc-action-btn--view"
                        onClick={() => renameFile(idx)}
                      >
                        <Edit2 size={12} />
                      </button>
                    </div>
                    <button
                      className="tc-action-btn tc-action-btn--accept"
                      style={{ color: "#ef4444", borderColor: "#ef4444" }}
                      onClick={() => removeFile(idx)}
                    >
                      <Trash2 size={12} />
                    </button>
                  </div>
                ))}
              </div>

              <div className="scc-form-footer">
                <span className="lq-count">
                  {files.length} {files.length === 1 ? "plik" : "plików"}
                </span>
                <button
                  className="lq-btn lq-btn--success"
                  onClick={uploadFiles}
                >
                  <Upload size={14} /> Dodaj pliki
                </button>
              </div>
            </>
          )}
        </div>
      </div>
    </div>
  );
};

export default AddFile;
